<template>
  <div class="theme-general-faq">
    <div
      class="title-aq">
      <h1>Tema general 4</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Nam consectetur quis nibh sed consectetur.
      </p>
    </div>
    <el-collapse
      v-for="(aq, index) in aqs"
      :key="index">
      <el-collapse-item
        v-bind="aqs"
        :title="aq.title"
        :name="index">
        <div> {{ aq.text }}</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'GeneralThemeFour',
  data () {
    return {
      aqs: [
        {
          title: 'Pregunta 1',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        },
        {
          title: 'Pregunta 2',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        },
        {
          title: 'Pregunta 3',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        },
        {
          title: 'Pregunta 4',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/faq/general-theme-four.vue